import { PatientStackParamList } from '@/navigations/PatientStack';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useEffect, useRef } from 'react';
import { AppState, AppStateStatus } from 'react-native';
import { IS_WEB } from '@/utils/platform';

export const usePrivacy = (isAuthenticated: boolean) => {
  const currentAppState = useRef(AppState.currentState);
  const navigation =
    useNavigation<StackNavigationProp<PatientStackParamList>>();

  const handleOnAppBlur = () => {
    navigation.navigate('Privacy');
  };

  const handleOnAppFocus = () => {
    navigation.canGoBack() && navigation.goBack();
  };

  const handleAppStateChange = (nextState: AppStateStatus) => {
    if (!isAuthenticated || IS_WEB) {
      return;
    }

    const notActive = nextState === 'inactive' || nextState === 'background';

    if (notActive) {
      handleOnAppBlur();
    } else {
      handleOnAppFocus();
    }
    currentAppState.current = nextState;
  };

  useEffect(() => {
    const subscription = AppState.addEventListener(
      'change',
      handleAppStateChange,
    );

    return () => {
      subscription.remove();
    };
  }, []);
};
